var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGameActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H7C4.8 22 3 20.2 3 18V6C3 3.8 4.8 2 7 2H17C19.2 2 21 3.8 21 6V18C21 20.2 19.2 22 17 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11H7.75C6.79 11 6 10.21 6 9.25V6.75C6 5.79 6.79 5 7.75 5H16.25C17.21 5 18 5.79 18 6.75V9.25C18 10.21 17.21 11 16.25 11Z",
    fill: "#EDAD0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8599 17.08L10.2099 16.43L10.8299 15.81C11.1199 15.52 11.1199 15.04 10.8299 14.75C10.5399 14.46 10.0599 14.46 9.76993 14.75L9.14993 15.37L8.55994 14.78C8.26994 14.49 7.78994 14.49 7.49994 14.78C7.20994 15.07 7.20994 15.55 7.49994 15.84L8.08994 16.43L7.46994 17.05C7.17994 17.34 7.17994 17.82 7.46994 18.11C7.61994 18.26 7.80994 18.33 7.99994 18.33C8.18994 18.33 8.37994 18.26 8.52994 18.11L9.14993 17.49L9.79993 18.14C9.94993 18.29 10.1399 18.36 10.3299 18.36C10.5199 18.36 10.7099 18.29 10.8599 18.14C11.1499 17.85 11.1499 17.37 10.8599 17.08Z",
    fill: "#EDAD0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 16.33C15.96 16.33 15.5 15.88 15.5 15.33C15.5 14.78 15.94 14.33 16.49 14.33H16.51C17.06 14.33 17.51 14.78 17.51 15.33C17.51 15.88 17.06 16.33 16.51 16.33Z",
    fill: "#EDAD0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.49 18.49C13.94 18.49 13.49 18.05 13.49 17.5V17.48C13.49 16.93 13.94 16.48 14.49 16.48C15.04 16.48 15.49 16.93 15.49 17.48C15.49 18.03 15.04 18.49 14.49 18.49Z",
    fill: "#EDAD0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameActive);
export default __webpack_public_path__ + "static/media/icon_game_active.abfe75495a8b06fccf92332b732ed74d.svg";
export { ForwardRef as ReactComponent };